import { type FunctionComponent } from 'react';
import { PLACEHOLDER_OPTIONS } from '../../../../constants/cloudinary/general';
import { type CloudinaryOptions } from '../../../../helpers/cloudinary-helper/cloudinary-helper';
import type { CarouselItemContent } from '../../../../types/construct.types';
import { LinkButton } from '../../../buttons/link-button/link-button.component';
import { Link } from '../../../common-components/link/link.component';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';

export type TipsInspirationSlideProps = {
	item: CarouselItemContent;
};

export const TipsInspirationSlide: FunctionComponent<TipsInspirationSlideProps> = ({ item }) => {
	const {
		title,
		subtitle,
		image,
		link: { linkUrl, trackingCode }
	} = item.fields;
	const options: CloudinaryOptions = { height: 794, width: 420, crop: 'mfit' };
	return (
		<div className="flex flex-column self-start justify-end theme-black w-auto relative" data-testid="tips-inspiration-slide">
			<div className="absolute z-1 bg-theme-white ph3 pb3 ba b--theme-grey-light w-100">
				<h3 className="f4 font-light lh-title pt2 ma0">{title}</h3>
				<span className="f6">{subtitle}</span>
				<div className="flex flex-row items-end justify-between mt3">
					<LinkButton url={linkUrl} buttonStyle="SECONDARY" size="SMALL" analyticsHook={trackingCode ?? undefined}>
						Read
					</LinkButton>
				</div>
			</div>
			<Link url={linkUrl} analyticsHook={trackingCode ?? undefined} ariaLabel={title}>
				<CloudinaryImage
					publicID={image.image?.id}
					description={image.image?.description ?? ''}
					options={options}
					useDimensions={false}
					placeholderOptions={{
						...options,
						...PLACEHOLDER_OPTIONS
					}}
					lowQualityPlaceholder={image.image?.lowQualityPlaceholder}
				/>
			</Link>
		</div>
	);
};
